import axios from 'axios';

export const getUsers = async () => axios.get("/api/users/");
export const changePassword = async (currentPassword, newPassword) => axios.patch(
  '/api/user/password/change/',
  {
    old_password: currentPassword,
    new_password: newPassword,
  }
);

export const getUserSettings = async () => await axios.get("/api/user/settings/");
export const patchUserSettings = async (data) => await axios.patch("/api/user/settings/", data);

export const getUserAppConfig = async () => {
  try {
    const response = await axios.get("/api/user/config/app/");
    return response.data;
  } catch (error) {
    return false;
  }
};

export const updateUserAppConfig = async (data) => {
  try {
    const response = await axios.patch("/api/user/config/app/", data);
    return response.data;
  } catch (error) {
    return false;
  }
};

// NOTE: copied here because import of feedApi was not working
export const loadUserEvents = async (args = {}) => {
  const {
    cursor,
    blockId,
    sensorIdentifier,
    sensorType,
    logLevel,
    active,
    eventType,
    eventCategory,
    dateStart,
    dateEnd,
    cancelToken,
    ranchId,
    q,
  } = args;
  const params = {};
  if (cursor) params['cursor'] = cursor;
  if (blockId) params['block'] = blockId;
  if (ranchId) params['ranch'] = ranchId;
  if (logLevel) params['log_level'] = logLevel;
  if (active) params['active'] = active;
  if (eventType) params['event_type'] = eventType;
  if (eventCategory) params['event_category'] = eventCategory;
  if (dateStart) params['date_start'] = dateStart.toDate().toISOString();
  if (dateEnd) params['date_end'] = dateEnd.toDate().toISOString();
  if (sensorType) params['sensor_type'] = sensorType;
  if (sensorIdentifier) params['sensor_identifier'] = sensorIdentifier;
  if (q) params['q'] = q;
  const baseUrl = '/api/feed/events/';
  const queryString = '?' + new URLSearchParams(params).toString();
  const url = baseUrl + queryString;
  return await axios.get(url, { cancelToken });
};

export const getCancelToken = () => axios.CancelToken.source();
